import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MessageSet } from 'src/app/core/models/message-set.model';

export interface MessageSetPreviewDialogData {
  messageSet: MessageSet;
}

@Component({
  selector: 'cm-message-set-preview-dialog',
  templateUrl: './message-set-preview-dialog.component.html',
  styleUrls: ['./message-set-preview-dialog.component.scss'],
})
export class MessageSetPreviewDialogComponent implements OnInit {
  messageSet: MessageSet;

  constructor(
    public dialogRef: MatDialogRef<MessageSetPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageSetPreviewDialogData
  ) {}

  ngOnInit(): void {
    this.messageSet = this.data.messageSet;
  }

  close(): void {
    this.dialogRef.close();
  }
}
